import { render, staticRenderFns } from "./Prices.vue?vue&type=template&id=37a4242e&scoped=true&"
import script from "./Prices.vue?vue&type=script&lang=js&"
export * from "./Prices.vue?vue&type=script&lang=js&"
import style0 from "./Prices.vue?vue&type=style&index=0&id=37a4242e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a4242e",
  null
  
)

export default component.exports